export default {
  en: {
    contact: {
      "1": "We're here to help!",
      "2":
        "You can reach us via<br/>%{supportPhones} or support@hungryhub.com or simply choose an option below"
    },
    d: {
      call: "Call",
      cancel: "Cancel",
      close: "Close",
      email: "Email",
      favourite: "Add to wishlist",
      see_all: "See all",
      share: "Share",
      show_less: "Show less",
      show_more: "Show more",
      support: "Support"
    },
    steps: {
      mob_heading: "More than %{count} diners seated, book your table today!",
      step1: {
        heading: "100+ restaurants",
        paragraph:
          "Best dining offers with curated restaurants in Bangkok and Chiang Mai"
      },
      step2: {
        heading: "Control your budget",
        paragraph:
          "Know exactly how much your bill will come to with our exclusive fixed-price packages"
      },
      step3: {
        heading: "Book now Pay later",
        paragraph:
          "Free booking and pay at the restaurant. Change of plans? Free cancellation too!"
      }
    },
    inventory: {
      full: "Fully booked! Try %{date}",
      full_booked: "Fully booked!",
      view_more: "View more time",
      booked_out: "Sold out",
      not_bookable: "Not bookable"
    },
    payment_method: {
      restaurant: "Pay at the restaurant"
    },
    pricing: {
      price: "Starting price per person",
      per_pack: "Starting price per pack",
      default: "Starting price"
    },
    cta_message: {
      last_booking: "Trending! Last booking was made",
      booked_by: "Popular! Booked by %{count} people",
      full: "Fully booked! Please change your date",
      new: "New! Book & review to earn 150 bonus points!",
      seat_left: "Only %{count} seats left for this time slot"
    },
    search: {
      sorry_no_result: "Sorry no result"
    },
    package: {
      pre_booking_for: "Pre-booking for %{date} onwards",
      valid_until: "Valid until %{date}",
      from: "from",
      pax: "pax"
    },
    reservation: {
      time: "Select a time to book",
      accept_tc: "Do you accept our Terms and Conditions?",
      last_booking_was_made: "Last booking was made",
      total_adult: "{count} adult | {count} adult | {count} adults",
      total_kids: "{count} kids | {count} kids | {count} kids"
    },
    restaurant: {
      booking_form: {
        desktop: {
          heading: "Book your table now",
          tables_available_for: "Tables available for"
        },
        free_booking_free_cancellation: "Free booking! Free cancellation!"
      },
      load_more: "See more restaurants / branches",
      pricing_with_from: '<small class="f7 fw3">From</small><br/>%{price}',
      sur: {
        "1": "Can't find your favorite restaurants?",
        "2": "Suggest us a restaurant",
        "3": "Suggest a restaurant",
        "4":
          "Let us know your favorite restaurant and we will try our best to get them on board. Thank you!",
        "5": "I'd like to suggest..."
      },
      v_new: {
        heading: "New Restaurants"
      },
      v_similar: {
        heading: "Similar Restaurants"
      },
      v_tag_group: {
        default_heading: "Other Promotions",
        total: "%{total} Restaurants"
      },
      v_top: {
        heading: "Top Restaurants"
      }
    },
    reviews: {
      small_rating_placeholder:
        "We are disappointed that you did not enjoy your meal, what happened and how can we or the restaurant improve?",
      medium_rating_placeholder:
        "What would you like us and the restaurant to improve?",
      high_rating_placeholder:
        "What did you like about Hungry Hub or the restaurant?",
      please_select_occasion: "Please select occasion",
      please_enter_all_ratings: "Please enter all ratings",
      x_characters_left: "%{x} characters left",
      to_s: "Review | Reviews"
    }
  },
  th: {
    contact: {
      "1": "เราพร้อมให้ความช่วยเหลือ!",
      "2":
        "คุณสามารถติดต่อเราผ่านทาง <br/>%{supportPhones} หรือ support@hungryhub.com หรือเพียงเลือกตัวเลือกด้านล่าง"
    },
    d: {
      call: "โทร",
      cancel: "ยกเลิก",
      close: "ปิด",
      email: "อีเมล",
      favourite: "เพิ่มในร้านโปรด",
      see_all: "ดูทั้งหมด",
      share: "แชร์",
      show_less: "ซ่อน",
      show_more: "ดูเพิ่ม",
      support: "สนับสนุน"
    },
    inventory: {
      booked_out: "ขายหมดแล้ว",
      not_bookable: "ร้านไม่รับการจอง",
      full: "โต๊ะเต็มแล้ว! ลอง %{date}",
      full_booked: "โต๊ะเต็มแล้ว!",
      view_more: "ดูเวลาอื่น"
    },
    search: {
      sorry_no_result: "ขออภัยไม่มีผลลัพธ์"
    },
    payment_method: {
      restaurant: "จองแล้วไปจ่ายเงินที่ร้าน"
    },
    pricing: {
      price: "ราคาเริ่มต้นต่อท่าน",
      per_pack: "ราคาเริ่มต้นต่อแพ็ก",
      default: "Starting price"
    },
    cta_message: {
      last_booking: "ร้านฮิต! จองครั้งสุดท้ายเมื่อ",
      booked_by: "มาแรง! %{count} คนจองร้านนี้แล้ว",
      full: "โต๊ะเต็มแล้ว! กรุณาเลือกวันอื่น",
      new: "ใหม่! จองแล้วรีวิวเพื่อรับโบนัส 150 คะแนน!",
      seat_left: "เหลือเพียง %{count} ที่นั่งเท่านั้นสำหรับเวลานี้"
    },
    package: {
      pre_booking_for: "จองวันนี้สำหรับทาน %{date} เป็นต้นไป",
      valid_until: "โปรโมชั่นถึง %{date}",
      from: "เริ่มต้น",
      pax: "ท่าน"
    },
    reservation: {
      time: "เลือกเวลาที่ต้องการจอง",
      accept_tc: "คุณยอมรับข้อกำหนดในการให้บริการของเราหรือไม่?",
      last_booking_was_made: "มีคนจองร้านนี้ครั้งสุดท้ายเมื่อ",
      total_adult: "{count} ผู้ใหญ่ | {count} ผู้ใหญ่ | {count} ผู้ใหญ่",
      total_kids: "{count} เด็ก | {count} เด็ก | {count} เด็ก"
    },
    restaurant: {
      booking_form: {
        desktop: {
          heading: "จองโต๊ะเดี๋ยวนี้",
          tables_available_for: "โต๊ะที่ว่างอยู่สำหรับ"
        },
        free_booking_free_cancellation: "จองฟรี! ยกเลิกไม่มีค่าใช้จ่าย!"
      },
      load_more: "ดูร้านอาหาร / สาขาเพิ่มเติม",
      pricing_with_from: '<small class="f7 fw3">เริ่มต้น</small><br/>%{price}',
      sur: {
        "1": "ไม่พบร้านอาหารที่คุณชื่นชอบ",
        "2": "แนะนำร้านอาหารให้เรา",
        "3": "แนะนำร้านอาหารให้เรา",
        "4":
          "แจ้งให้เราทราบร้านอาหารที่คุณชื่นชอบและเราจะพยายามอย่างดีที่สุดเพื่อให้พวกเขาขึ้นเรือ ขอขอบคุณ!",
        "5": "ฉันอยากจะแนะนำ ..."
      },
      v_new: {
        heading: "ร้านอาหารใหม่"
      },
      v_similar: {
        heading: "ร้านอาหารที่คล้ายกัน"
      },
      v_tag_group: {
        default_heading: "โปรโมชั่นอื่น ๆ",
        total: "%{total} ร้านอาหาร"
      },
      v_top: {
        heading: "ร้านอาหารยอดนิยม"
      }
    },
    reviews: {
      small_rating_placeholder:
        "เสียใจจังที่ประสบการณ์ทานอาหารของคุณไม่ดี ช่วยบอกเราหน่อยว่าเกิดอะไรขึ้นและต้องการให้เราหรือร้านอาหารปรับปรุงด้านใด",
      medium_rating_placeholder: "ต้องการให้เราหรือร้านอาหารปรับปรุงด้านใด",
      high_rating_placeholder:
        "ชื่นชอบอะไรเกี่ยวกับ Hungry Hub หรือร้านอาหารเป็นพิเศษ",
      please_select_occasion: "กรุณาเลือกโอกาส",
      please_enter_all_ratings: "กรุณาให้คะแนนทุกข้อ",
      x_characters_left: "เขียนได้อีก %{x} ตัวอักษร",
      to_s: "รีวิว | รีวิว"
    }
  },
  ko: {
    js: {
      d: {
        call: "전화하기",
        cancel: "취소",
        close: "닫기",
        email: "이메일",
        favourite: "특히 잘하는",
        see_all: "전체보기",
        share: "공유하기",
        show_less: "덜 보기",
        show_more: "더 보기",
        support: "고객센터"
      },
      inventory: {
        booked_out: "매진",
        not_bookable: "예약이 가능하지 않습니다"
      },
      package: {
        pre_booking_for: "Pre-booking for %{date} onwards",
        valid_until: "Valid until %{date}"
      },
      reservation: {
        accept_tc: "이용 약관에 동의합니까?",
        last_booking_was_made: "최근 예약",
        total_adult: "{count} 성인 | {count} 성인 | {count} 성인",
        total_kids:
          "{count} 소인(140cm 이하) | {count} 소인(140cm 이하) | {count} 소인(140cm 이하)"
      },
      search: {
        sorry_no_result: "죄송합니다.결과가 없습니다."
      },
      restaurant: {
        booking_form: {
          desktop: {
            heading: "Book your table now",
            tables_available_for: "Tables available for"
          },
          free_booking_free_cancellation: "Free booking! Free cancellation!"
        },
        from_pricing: "%{price} 이상",
        load_more: "계속 검색",
        pricing_with_from: '%{price}<br/><small class="f7 fw3">이상</small>',
        sur: {
          "1": "단골 식당을 찾을 수 없으신가요?",
          "2": "저희에게 식당을 추천 해주세요.",
          "3": "제안하기",
          "4":
            "저희에게 단골 식당을 알려주시면 헝그리 허브(Hungry Hub)에서 이용이 가능하도록 최선을 다하겠습니다.",
          "5": "...을 제안하고 싶습니다."
        },
        v_new: {
          heading: "새로운 식당"
        },
        v_similar: {
          heading: "비슷한 식당"
        },
        v_tag_group: {
          default_heading: "다른 프로모션",
          total: "%{total} 식당"
        },
        v_top: {
          heading: "톱랭크 식당"
        }
      },
      reviews: {
        small_rating_placeholder:
          "We are disappointed that you did not enjoy your meal, what happened and how can we or the restaurant improve?",
        medium_rating_placeholder:
          "What would you like us and the restaurant to improve?",
        high_rating_placeholder:
          "What did you like about Hungry Hub or the restaurant?",
        x_characters_left: "%{x} characters left",
        to_s: "리뷰 | 리뷰"
      }
    }
  }
};
